<template>
  <div id="app">
    <div v-if="loading == false">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <kid-footer></kid-footer>
    </div>
    <div
      v-else
      class="loading flex justify-center"
      style="min-height: 7rem; margin-top: 2rem"
    >
      <span class="size bg-color-23"></span>
      <span class="size bg-color-23"></span>
      <span class="size bg-color-23"></span>
    </div>
  </div>
</template>

<script>
import common from "@/utils/common.js";
import Cookies from 'js-cookie'
export default {
  name: "App",
  data() {
    return {
      loading: true,
    };
  },
  created() {
    this.checkToken();
    var newotime = new Date().getTime()
    var url = "https://h5.cdn.bjadks.com/Player/g.css"
    const savetime = Cookies.get("currstamp")
    if (savetime) {
      if ((newotime - savetime) / 60 / 1000 > 1) {
        url = "https://h5.cdn.bjadks.com/Player/g.css?t=" + newotime
        Cookies.set("currstamp", newotime)
      } else {
        url = "https://h5.cdn.bjadks.com/Player/g.css?t=" + savetime
      }
    } else {
      Cookies.set("currstamp", newotime)
      url = "https://h5.cdn.bjadks.com/Player/g.css?t=" + newotime
    }
    let style = document.createElement("link")
    style.href = url
    style.rel = "stylesheet"
    document.body.append(style)
  },
  methods: {
    checkToken() {
      if (window.location.href.indexOf("/index") != -1) {
        this.loading = false;
        return;
      }
      if (window.location.href.indexOf("/AutoLogin/login") != -1) {
        this.loading = false;
        return;
      }
      var token = common.getCookie("utoken") || '';
      if (token == "") {
        var httpurl = localStorage.getItem("islogin_httpurl") || "";
        if (httpurl == "") {
          this.loading = false;
          localStorage.setItem("islogin_httpurl", window.location.href);
          this.$router.replace({
            name: "index",
            params: {
              isfirst: "first",
              states: "auto",
            },
          });
          return;
        }
      }
      this.requestCate();
    },
    requestCate() {
      var that = this;
      this.getRequest("api/v1/Catalog/GetFirstLevel").then((data) => {
        common.cate_fr = data;
        localStorage.removeItem("islogin_httpurl");
        that.loading = false;
      });
    },
    //   isLogin() {
    //   var islogin = localStorage.getItem("isLogin") || "";
    //   if (islogin == "") {
    //     console.log('自动登录');
    //     localStorage.setItem("isLogin", "islogin");
    //     var http =
    //       "https://login.bjadks.com/Auth/AutoLogin?productId=10&redirectUrl=" +
    //       encodeURI(window.location.href)
    //     window.open(http, "_self");
    //   } else {
    //     this.requestCate()
    //     localStorage.removeItem("isLogin");
    //   }
    // },
    // getToken() {
    //   var token = this.getQueryString("token");
    //     if (token == null) {
    //       console.log('token 为空');
    //       common.u_token = localStorage.getItem("login") || "";
    //       if (common.u_token != "") {
    //         console.log('请求用户数据');
    //         this.loginData(common.u_token);
    //       } else {
    //         console.log('去登录');
    //         this.isLogin();
    //       }
    //     } else {
    //       common.u_token = token;
    //       this.loginData(common.u_token);
    //     }
    // },
    // getQueryString(name) {
    //   var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    //   var r = window.location.search.substr(1).match(reg);
    //   if (r != null) return unescape(r[2]);
    //   return null;
    // },
    // loginData(token) {
    //   var that = this;
    //   this.getRequest("api/v1/User", {
    //     token: token
    //   }).then(data => {
    //     that.requestCate()
    //     if (data.IsSuccess) {
    //       common.userBase = data.Data;
    //     } else {
    //       common.userBase = null;
    //       this.$toast.error(data.Message);
    //     }
    //   });
    // }
  },
};
</script>

<style>

.error {
  min-height: 7rem;
}
body {
  font-size: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue